import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Lines, ImgReveal, FadeUp } from "../components/Reveal";

export default function ProductStory() {
    return (
        <section data-testid="featured-story" className="mx-auto max-w-[1600px] px-5 py-24 sm:px-8 lg:px-16 lg:py-40">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-20">
                <div className="lg:sticky lg:top-28 lg:self-start">
                    <ImgReveal
                        src="/assets/STORY_SNAKE.jpg"
                        alt="Snake Edition hoodie — featured piece"
                        className="aspect-[4/5] w-full bg-[#ECEAE4]"
                    />
                </div>
                <div className="flex flex-col justify-center lg:min-h-[80vh]">
                    <p className="mb-4 text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">06 — Featured Piece</p>
                    <Lines
                        lines={["Snake", "Edition"]}
                        className="font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter text-[#0A0A0A] sm:text-7xl"
                    />
                    <FadeUp delay={0.2}>
                        <p className="mt-10 max-w-md text-base leading-relaxed text-[#8E8D8A]">
                            Designed around transformation, movement and perspective. Tonal snake embroidery runs across the
                            back panel — visible only when you move. Heavyweight 480 GSM fleece, garment-dyed in Canada.
                        </p>
                    </FadeUp>
                    <FadeUp delay={0.3}>
                        <ul className="mt-10 space-y-3 border-t border-[rgba(10,10,10,0.12)] pt-8">
                            {["Tonal back embroidery", "480 GSM heavyweight fleece", "Chrome aglet tips", "Limited to 300 units"].map((d) => (
                                <li key={d} className="flex items-center gap-4 text-[11px] uppercase tracking-[0.2em] text-[#8E8D8A]">
                                    <span className="h-px w-6 bg-[#333]" />
                                    {d}
                                </li>
                            ))}
                        </ul>
                    </FadeUp>
                    <FadeUp delay={0.4}>
                        <Link
                            data-testid="story-shop-piece"
                            data-cursor="SHOP"
                            to="/product/p01"
                            className="group mt-12 inline-flex items-center gap-3 font-display text-[11px] font-bold uppercase tracking-[0.35em] text-[#0A0A0A]"
                        >
                            <span className="link-underline">Shop The Piece</span>
                            <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-2" />
                        </Link>
                    </FadeUp>
                </div>
            </div>
        </section>
    );
}
